import * as yup from "yup";

yup.addMethod<yup.StringSchema>(
  yup.string,
  "emailWithValidTLD",
  function (message = "Provide valid email") {
    return this.email(message).matches(
      /^[a-zA-Z0-9._%+éèêëàâäçîïôöùûüÿ-]+@([a-zA-Z0-9éèêëàâäçîïôöùûüÿ-]+\.)+[a-zA-Zéèêëàâäçîïôöùûüÿ]{2,}$/,
      { message, excludeEmptyString: true },
    );
  },
);
